import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProofSection } from '../components/ProofSection';
import { ProblemSection } from '../components/ProblemSection';
import { SystemSection } from '../components/SystemSection';
import { InsideMaterialCarousel } from '../components/InsideMaterialCarousel';
import { ModulesSection } from '../components/ModulesSection';
import { BonusSection } from '../components/BonusSection';
import { UrgencySection } from '../components/UrgencySection';
import { PricingSection } from '../components/PricingSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="min-h-screen w-full overflow-hidden bg-white" data-id="element-278" data-mp="lm5x1siyrtqa">
      <HeroSection data-id="element-279" data-mp="lnz5ndd50o0x" />
      <ProofSection data-id="element-280" data-mp="2zj6yl4bnnn57" />
      <ProblemSection data-id="element-281" data-mp="2zjq75uff0z6k" />
      <SystemSection data-id="element-282" data-mp="2zki2r590iwwu" />
      <InsideMaterialCarousel data-id="element-283" data-mp="2zgu9863kiai4" />
      <ModulesSection data-id="element-284" data-mp="33k8yzohb658r" />
      <BonusSection data-id="element-285" data-mp="33lk53uy87p31" />
      <UrgencySection data-id="element-286" data-mp="33l1x6127bmfa" />
      <PricingSection data-id="element-287" data-mp="33i60sh6055sy" />
      <TestimonialsSection data-id="element-288" data-mp="38jvc7xx4zlhk" />
      <GuaranteeSection data-id="element-289" data-mp="38ik9m1ffgjs1" />
      <FAQSection data-id="element-290" data-mp="38iaigainc6kr" />
      <FinalCTA data-id="element-291" data-mp="38hseerpqso2a" />
      <Footer data-id="element-292" data-mp="3da20fwnql3za" />
    </main>;
}